import { BasicCriteria, BasicScenario, ConnectActionWrapper } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../../model/external-api';
import { Model } from '../../../model/model';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD, WIZ_COMMAND_STATE} from '@wizeoo/akm-core-lib';
import { DomainVO } from '../../../vo/core/domain.vo';

/**
 * Commande REST de recherche des cnx
 */
export class FindConnectCommand extends WizCommand<ConnectActionWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  
    const wrapper: ConnectActionWrapper = new ConnectActionWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.criteria = new BasicCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    this.configureRemote(ExternalAPI.CONNECT_API, wrapper);
  }

  /** 
   * chargement de toutes les fonctions connect disponibles
   * @returns 
   */
  public findForCnx(): FindConnectCommand {

    const wrapper: ConnectActionWrapper = new ConnectActionWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.criteria = new BasicCriteria();
    const doms: DomainVO[] = this.model.connectedUser.allDomains;
    if (doms) {
      wrapper.criteria.domainList = doms.map((item) => item.code);
    } else {
      wrapper.criteria.domain = this.model.domainCode;
    }


    this.configureRemote(ExternalAPI.CONNECT_API, wrapper);
    return this;
  }



  wizResult() {
    super.wizResult();
    if (this.state === WIZ_COMMAND_STATE.SUCCESS) {
      this.model.connectEngine.buildMap(this.result.entities);
    }
  }
}
